export default function Cancel(){
    return(
        <div style={{marginTop:"80px",color:"red",fontWeight:"600"}}>
           <h4>YOUR PAYMENT IS UNSUCCESSFUL</h4> 
        </div>
    )
}